function e(e,r,n){return r in e?Object.defineProperty(e,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[r]=n,e}export{e as _};
//# sourceMappingURL=defineProperty-1e8516b1.js.map
